var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
export var Styled = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-style: italic;\n  width: 100px;\n  height: 25px;\n  display: flex;\n  align-items: center;\n  opacity: 1;\n  ", ";\n"], ["\n  font-style: italic;\n  width: 100px;\n  height: 25px;\n  display: flex;\n  align-items: center;\n  opacity: 1;\n  ",
    ";\n"])), function (props) {
    return props.fadeOut &&
        "\n  transition: 1s ease-in-out;\n    opacity: 0;\n  ";
});
var templateObject_1;
//# sourceMappingURL=style.js.map